<template>
  <div class="lang" role="group" :aria-label="t('languageLabel')">
    <button
      v-for="code in languages"
      :key="code"
      type="button"
      class="lang__option"
      :class="{ 'lang__option--active': code === language }"
      :aria-pressed="code === language"
      @click="setLanguage(code)"
    >
      {{ code.toUpperCase() }}
    </button>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { useBrandStore } from '@/stores/brandStore'

const brandStore = useBrandStore()
const { language, languages } = storeToRefs(brandStore)
const { t, setLanguage } = brandStore
</script>

<style scoped>
.lang {
  display: inline-flex;
  padding: 3px;
  border-radius: 999px;
  background: rgba(11, 14, 23, 0.72);
  border: 1px solid rgba(255, 255, 255, 0.14);
  backdrop-filter: blur(6px);
}

.lang__option {
  min-width: 40px;
  padding: 5px 10px;
  border-radius: 999px;
  background: transparent;
  color: var(--color-text-secondary);
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  transition: background-color var(--transition-fast), color var(--transition-fast);
}

.lang__option--active {
  background: var(--color-primary);
  color: var(--color-on-primary);
}

.lang__option:focus-visible {
  outline: 2px solid var(--color-accent);
  outline-offset: 1px;
}
</style>
